/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dedication_Optional_Printed_As_Its_Own_PageInputs */

const en_dedication_optional_printed_as_its_own_page = /** @type {(inputs: Dedication_Optional_Printed_As_Its_Own_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedication (Optional — Printed as its own page)`)
};

const es_dedication_optional_printed_as_its_own_page = /** @type {(inputs: Dedication_Optional_Printed_As_Its_Own_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedicatoria (Opcional - Impresa en su propia página)`)
};

const fr_dedication_optional_printed_as_its_own_page = /** @type {(inputs: Dedication_Optional_Printed_As_Its_Own_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dédicace (Facultatif - Imprimée sur sa propre page)`)
};

const de_dedication_optional_printed_as_its_own_page = /** @type {(inputs: Dedication_Optional_Printed_As_Its_Own_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widmung (Optional - Wird als eigene Seite gedruckt)`)
};

const ja_dedication_optional_printed_as_its_own_page = /** @type {(inputs: Dedication_Optional_Printed_As_Its_Own_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`献辞 (任意 - 単独のページとして印刷されます)`)
};

const zh_dedication_optional_printed_as_its_own_page = /** @type {(inputs: Dedication_Optional_Printed_As_Its_Own_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`献词 (可选 - 将作为独立页面打印)`)
};

const ar_dedication_optional_printed_as_its_own_page = /** @type {(inputs: Dedication_Optional_Printed_As_Its_Own_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إهداء (اختياري - يُطبع كصفحة مستقلة)`)
};

const id_dedication_optional_printed_as_its_own_page = /** @type {(inputs: Dedication_Optional_Printed_As_Its_Own_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedikasi (Opsional - Dicetak sebagai halaman tersendiri)`)
};

const it_dedication_optional_printed_as_its_own_page = /** @type {(inputs: Dedication_Optional_Printed_As_Its_Own_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedica (Opzionale - Stampata come pagina a sé stante)`)
};

const ru_dedication_optional_printed_as_its_own_page = /** @type {(inputs: Dedication_Optional_Printed_As_Its_Own_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посвящение (Необязательно - печатается на отдельной странице)`)
};

const pt_dedication_optional_printed_as_its_own_page = /** @type {(inputs: Dedication_Optional_Printed_As_Its_Own_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dedicatória (Opcional - Impressa na sua própria página)`)
};

const ko_dedication_optional_printed_as_its_own_page = /** @type {(inputs: Dedication_Optional_Printed_As_Its_Own_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`헌사 (선택 사항 - 단독 페이지로 인쇄됨)`)
};

/**
* | output |
* | --- |
* | "Dedication (Optional — Printed as its own page)" |
*
* @param {Dedication_Optional_Printed_As_Its_Own_PageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const dedication_optional_printed_as_its_own_page = /** @type {((inputs?: Dedication_Optional_Printed_As_Its_Own_PageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dedication_Optional_Printed_As_Its_Own_PageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dedication_optional_printed_as_its_own_page(inputs)
	if (locale === "es") return es_dedication_optional_printed_as_its_own_page(inputs)
	if (locale === "fr") return fr_dedication_optional_printed_as_its_own_page(inputs)
	if (locale === "de") return de_dedication_optional_printed_as_its_own_page(inputs)
	if (locale === "ja") return ja_dedication_optional_printed_as_its_own_page(inputs)
	if (locale === "zh") return zh_dedication_optional_printed_as_its_own_page(inputs)
	if (locale === "ar") return ar_dedication_optional_printed_as_its_own_page(inputs)
	if (locale === "id") return id_dedication_optional_printed_as_its_own_page(inputs)
	if (locale === "it") return it_dedication_optional_printed_as_its_own_page(inputs)
	if (locale === "ru") return ru_dedication_optional_printed_as_its_own_page(inputs)
	if (locale === "pt") return pt_dedication_optional_printed_as_its_own_page(inputs)
	return ko_dedication_optional_printed_as_its_own_page(inputs)
});